import { Routes } from '@angular/router';
import { AuthGuard } from '../../guard/auth-guard/auth.guard';
import { navigationStateGuard } from '../../core/guards/navigation-state.guard';

export const profissionalHomolRoutes: Routes = [
  {
    path: 'profissional',
    redirectTo: 'profissional-homol',
    pathMatch: 'full',
  },
  {
    path: 'profissional-homol',
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        data: {
          title: 'Validar e homologar Profissional',
          breadcrumb: [{ label: 'Validar e homologar Profissional', url: '/profissional-homol' }],
        },
        loadComponent: () =>
          import('./profissional.component').then((m) => m.ProfissionalComponent),
      },
      {
        path: 'validar/:id',
        canActivate: [navigationStateGuard],
        data: {
          title: 'Validar / Homologar Profissional',
          breadcrumb: [
            { label: 'Validar e homologar Profissional', url: '/profissional-homol' },
            { label: 'Validar / Homologar' },
          ],
        },
        loadComponent: () =>
          import('./validar-homologar/validar-homologar.component').then(
            (m) => m.ValidarHomologarComponent,
          ),
      },
      {
        path: 'editar/:id',
        canActivate: [navigationStateGuard],
        data: {
          title: 'Editar Validação e Homologação',
          breadcrumb: [
            { label: 'Validar e homologar Profissional', url: '/profissional-homol' },
            { label: 'Editar Validação e Homologação' },
          ],
        },
        loadComponent: () =>
          import('./validar-homologar/validar-homologar.component').then(
            (m) => m.ValidarHomologarComponent,
          ),
      },
      {
        path: 'visualizar/:id',
        canActivate: [navigationStateGuard],
        data: {
          title: 'Visualizar Profissional',
          breadcrumb: [
            { label: 'Validar e homologar Profissional', url: '/profissional-homol' },
            { label: 'Visualizar' },
          ],
        },
        loadComponent: () =>
          import('./validar-homologar/validar-homologar.component').then(
            (m) => m.ValidarHomologarComponent,
          ),
      },
    ],
  },
];
